// Cookie library. Vaguely based on a few Stack Overflow articles
//
// Consider using window.localStorage instead.
//
"use strict";

/**
 * Returns value for cookie 'name' or false if not found.
 */
export function get(name) {
    var cookies = document.cookie.split(';');
    var i;
    var rx = RegExp("^ *" + name + "=(.*) *$")
    for (i = 0; i < cookies.length; i++) {
        var m = rx.exec(cookies[i]);
        if (m && m[1]) {
            return m[1];
        }
    }
    return false;
}

/**
 * Deletes a cookie.
 * 
 * @param {string} name Cookie name
 */
export function clear(name) {
    set(name, '', -365 * 24 * 60 * 60 * 1000);
}

/**
 * Sets a cookie.
 * 
 * name and value only allow certain values (per RFC)
 * expires is milliseconds from now
 */
export function set(name, value, expires) {
    var cookie = name + "=" + value + "; path=/";

    if (expires !== 0) {
        var date = new Date();
        date.setTime(date.getTime() + expires);
        cookie += "; expires=" + date.toGMTString();   
    }

    cookie += "; samesite=lax";

    if (window.document.location.protocol == 'https') {
        cookie += "; secure";
    }
    
    document.cookie = cookie;
}
